import React from "react"

import { reportIcons } from "../../../../../shared/Data/reportIcons"

import {Button} from 'react-bootstrap'


export const instructionFigures = (
  <div className="cover-pages-binder" style={{ height: 996, position: 'relative' }}>
        <div className="sum-title">How to Read this Report</div>
        <div className="legend-grid" style={{ position: 'absolute', top: 100 }}>
          <div className="col1">
            <div className="entry">
              <div className="entry-num">1</div>
              <div className="entry-text">
                <div className="entry-title">Header</div>
                The top bar identifies the category, and the text below identifies the subcategory and corresponding code
              </div>
            </div>
            <div className="entry">
              <div className="entry-num">2</div>
              <div className="entry-text">
                <div className="entry-title">Integrated Coding System</div>
                The code indicates the category and subcategory. Our proprietary coding system ties together information
                throughout the report, allowing for easy cross-referencing between the narrative, the recommendations,
                and the budget.
              </div>
            </div>
            <div className="entry">
              <div className="entry-num">3</div>
              <div className="entry-text">
                <div className="entry-title">Overall Condition</div>
                The colored bar indicates the observed level of wear. These ratings do not necessarily reflect the need
                for a specific repair in the short term. For example, if a roof in excellent condition overall has a
                leak because of vandalism, the roof will be rated excellent, and the leak will be addressed in the narrative.
              </div>
            </div>
            <div className="entry">
              <div className="entry-title">Estimate remaining useful life</div>
              <div className="rating">
                <Button variant="danger" className="unsatisfactory">Unsatisfactory</Button>
              </div>
              {"<10%"}
              <div className="rating">
                <Button variant="warning" className="fair">Fair</Button>
              </div>
              {"10-49%"}
              <div className="rating">
                <Button variant="success" className="satisfactory">Satisfactory</Button>
              </div>
              {"50-89%"}
              <div className="rating">
                <Button variant="primary" className="good">Good</Button>
              </div>
              {"90-100%"}
            </div>
          </div>
          <div className="figure-box" >

            <div className="figure-number figure1">1</div>
            <div className="figure-number figure2">2</div>
            <div className="figure-number figure3">3</div>
            <div className="figure-number figure4">4</div>
            <div className="figure-number figure5">5</div>
            <div className="figure-number figure6">6</div>
            <div className="figure-number figure7">7</div>

            <div className="title">Lighting</div>
            <div className="sub-title">205.010 &mdash; Exterior Lighting</div>

            <div className="example-report-grid">
              <div className="example-recommendation">
                <div className="recommendation" style={{ borderBottom: '2px solid #d0d0d0', width: 115 }}>
                  <div>
                    <div className="rating" style={{marginBottom: 5}}>
                      <Button variant="warning" size="sm" className="fair" style={{
                        width: 115,
                        height: 26,
                        fontSize: 12
                      }}>Fair</Button>
                    </div>
                  </div>

                </div>
                <div style={{ margin: 'auto' }}>

                  {/*const iconSize = 601
                        const iconSizePercent = 5
                        const baseSize = (iconSize / 100) * iconSizePercent

                        let backgroundPositionX = (((reportIcons.length*iconSize)- (9*iconsize)) / 100) * iconSizePercent
                        backgroundPositionX: (((601*reportIcons.length)-(2*601))/100)*0.05,


                        if( backgroundPositionX > 385 ) backgroundPositionX = 0*/}

                  <div
                    style={{
                      height: 601 * 0.05,
                      width: 601 * 0.05,
                      backgroundSize: 'cover',
                      backgroundImage: `url(${reportIcons[2].image})`,
                      backgroundPositionX: ((reportIcons.length * 601) - (2 * 601)) * 0.05,
                      paddingRight: 7,
                      margin: 'auto'

                    }} />

                </div>
                <div className="recommendation-text">
                  Replace damaged wallmounted exterior light fixtures with LED fixtures.
                </div>
              </div>
              <div className="example-narrative">
                The exterior lighting is generally is satisfactory condition. The courtyard
                lighting are LED fixtures and are in satisfactory condition. The wallmounted
                fixtures use compact flourescent lamp bulbs and are in fair condition. Seven
                of the wall-mounted fixtures are dented and corroded. We recommend that
                damaged fixtures be replaced with LED fixtures
              </div>
              <div className="example-image1">
                <div
                  style={{
                    width: 160,
                    height: 120,
                    backgroundSize: 'cover',
                    backgroundImage: `url("./example-image1.png")`
                  }}
                />
                <div className="image-caption">Wall-mounted fixture</div>
              </div>
              <div className="example-image2">
                <div
                  style={{
                    width: 160,
                    height: 120,
                    backgroundSize: 'cover',
                    backgroundImage: `url("./example-image2.png")`
                  }}
                />
                <div className="image-caption">Courtyard lighting</div>
              </div>
            </div>
          </div>
          <div className="col2">
            <div className="entry">
              <div className="entry-num">4</div>
              <div className="entry-text">
                <div className="entry-title">Icons</div>
                Icons helps identify, at a glance, the type of recommendation given.
              </div>
            </div>
            <div className="entry-title">Icon Meanings</div>
            <div className="icon-list">
              {
                reportIcons.slice(0, 13).map(icon => {
                  const iconSize = 601
                  const iconSizePercent = 5
                  const baseSize = (iconSize / 100) * iconSizePercent
                  console.log('making icons', { baseSize, iconSize, icon, iconSizePercent })
                  let backgroundPositionX = (icon.offset / 100) * iconSizePercent

                  // if (backgroundPositionX > 385) backgroundPositionX = 0

                  return (
                    <div style={{ height: 25 }}>
                      <div
                        style={{
                          height: baseSize,
                          width: baseSize,
                          backgroundSize: 'cover',
                          backgroundImage: `url(${icon.image})`,
                          backgroundPositionX,
                          display: 'inline-block'
                        }} />
                      <div style={{
                        fontSize: 14,
                        verticalAlign: 'super',
                        display: 'inline-block'
                      }}>
                        &nbsp;&mdash;&nbsp;
                        {icon._mask}
                      </div>
                    </div>
                  )
                })
              }
            </div>
          </div>
          <div className="col3">

            <div className="entry">
              <div className="entry-num">5</div>
              <div className="entry-text">
                <div className="entry-title">Recommendation</div>
                Recommendations identify specific steps that should be taken to
                preserve and improve the condition of the property.
              </div>
            </div>

            <div className="entry">
              <div className="entry-num">6</div>
              <div className="entry-text">
                <div className="entry-title">Narrative</div>
                The narrative provides a description of the conditions observed during
                our on-site visit, including items that need to be addressed and other
                relevant comments.
              </div>
            </div>

            <div className="entry">
              <div className="entry-num">7</div>
              <div className="entry-text">
                <div className="entry-title">Photos</div>
                To identify typical conditions, we select representative
                photos from a large volume of photos taken during the on-site
                inspection.
              </div>
            </div>

          </div>
        </div>
      </div>
)

export const budgetMethodology = `
### **Cost Estimating Methodology**
The cost estimates detailed in this report reflect the typical cost for each item. Where we are
not able to establish the extent, quantity, or quality of an item accurately (i.e., the source
of a leak, etc.), our extensive experience allows us to provide cost allowance estimates for
any required work. Items requiring maintenance or simple repair that are mentioned in any
specific narrative are not always included in the estimate, especially if a decision or
selection must be made to establish a cost. Items contained in the Cost Estimate include:

* Items in need of major repair or replacement
* Components that are near or past the end of their expected useful life (EUL)
* Significant deferred maintenance items
* Improvements that will significantly extend the life of a site or building
component
* Measures that represent significant and immediate utility savings
* Items that are a health or safety concern
* Improvement goals that have been identified by the owner


\nWhen work in progress has been observed, for cost estimating purposes, it is assumed to be
completed; unless it was also observed to be unacceptable in quality or scope.
`